export default function wsMediaQuery() {
    console.log('youfoundus');
    let defaults = {
        target: "document",
        mediaQuery: "all",
        matches: function() { console.log("Matched!"); },
        unmatches: function() { console.log("Didn't match!"); },
    }
    
    this.properties = {
        matched: false,
    }

    this.options = { 
 
    }

    // Create options by extending defaults with the passed in arugments
    if (arguments[0] && typeof arguments[0] === "object") {
        this.options = extendDefaults(defaults, arguments[0]);
    }

    // Private Methods
    function extendDefaults(source, properties) {
        let property;
        for (property in properties) {
            if (properties.hasOwnProperty(property)) {
                source[property] = properties[property];
            }
        }
        return source;
    }

    this.init(); 
}

// Private Functions
wsMediaQuery.prototype.init = function() {
    let _this = this;
    this.mq();
    window.matchMedia(this.options.mediaQuery).addListener(function(){
        _this.mq();
    });
}

wsMediaQuery.prototype.mq = function() {
    let _this = this;
    if (window.matchMedia(this.options.mediaQuery).matches) {
        this.options.matches(); 
    } else {
        this.options.unmatches(); 
    }
} 